import { JSGraph as OriginalJSGraph } from 'common-spectrum';

export const JSGraph = { ...OriginalJSGraph };

JSGraph.getJSGraph = function getJSGraph(data, options) {
  return OriginalJSGraph.getJSGraph(data, {
    xAxis: { logScale: true },
    ...options,
  });
};

export { Analysis, AnalysesManager, fromJcamp, toJcamp } from 'common-spectrum';

export * from './from/fromCPS';
